import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useI18n } from "../lib/i18n";
import { useAuth } from "../lib/auth";
import { QrCode } from "@phosphor-icons/react";

export default function Navbar() {
    const { t, lang, setLang } = useI18n();
    const { user, logout } = useAuth();
    const loc = useLocation();
    const isLanding = loc.pathname === "/";

    const scrollTo = (id) => (e) => {
        e.preventDefault();
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <nav className="sticky top-0 z-50 glass-nav" data-testid="navbar">
            <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 h-16 flex items-center justify-between">
                <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
                    <span className="w-9 h-9 rounded-2xl bg-brand-primary text-white flex items-center justify-center">
                        <QrCode size={20} weight="bold" />
                    </span>
                    <span className="font-display text-xl tracking-tight">QR Bracelet<span className="text-brand-primary">.</span></span>
                </Link>

                <div className="hidden md:flex items-center gap-8 text-sm text-brand-text/80">
                    {isLanding && (
                        <>
                            <a href="#how" onClick={scrollTo("how")} className="hover:text-brand-primary transition" data-testid="nav-how">{t.nav.how}</a>
                            <a href="#features" onClick={scrollTo("features")} className="hover:text-brand-primary transition" data-testid="nav-features">{t.nav.features}</a>
                            <a href="#use-cases" onClick={scrollTo("use-cases")} className="hover:text-brand-primary transition" data-testid="nav-usecases">{t.nav.useCases}</a>
                            <a href="#order" onClick={scrollTo("order")} className="hover:text-brand-primary transition" data-testid="nav-order">{t.nav.order}</a>
                        </>
                    )}
                </div>

                <div className="flex items-center gap-2">
                    <div className="flex items-center bg-white border border-brand-border rounded-full p-1 text-xs font-mono" data-testid="lang-switcher">
                        <button onClick={() => setLang("ro")} className={`px-3 py-1 rounded-full transition ${lang === "ro" ? "bg-brand-secondary text-white" : "text-brand-textMuted"}`} data-testid="lang-ro">RO</button>
                        <button onClick={() => setLang("en")} className={`px-3 py-1 rounded-full transition ${lang === "en" ? "bg-brand-secondary text-white" : "text-brand-textMuted"}`} data-testid="lang-en">EN</button>
                    </div>
                    {user ? (
                        <>
                            <Link to="/dashboard" className="hidden sm:inline-flex text-sm px-4 py-2 rounded-full border border-brand-border hover:border-brand-text transition" data-testid="nav-dashboard">{t.nav.dashboard}</Link>
                            <button onClick={logout} className="text-sm px-4 py-2 rounded-full btn-secondary" data-testid="nav-logout">{t.nav.logout}</button>
                        </>
                    ) : (
                        <Link to="/login" className="text-sm px-4 py-2 rounded-full btn-secondary" data-testid="nav-login">{t.nav.login}</Link>
                    )}
                </div>
            </div>
        </nav>
    );
}
